import { Product } from "../constants/product.constant";
export const handleMecanic = (product, className) => {
console.log('product', product)

	if (product?.product_detail?.category === "Magistral Recipe" && product?.quotation_price?.have_discount) {
		console.log('tiene descuento', product.quotation_price)
		return <h5 className={className}> - {parseInt(product.quotation_price?.discount_value)}% OFF</h5>;
	}

	if (product.promotions === null) {
		return <h5 className="mecanic-none"> </h5>;
	}

	if (product.promotions?.rules?.mecanic === Product.mecanicDiscountOff) {
		return <h5 className={className}> - {parseInt(product.promotions?.rules?.benefit)}% OFF</h5>;
	}

	if (product.promotions?.rules?.mecanic === Product.mecanicNxM) {
		return (
			<h5 className={className}>
				{product.promotions?.rules?.quantity_per_requeriment} x {product.promotions?.rules?.quantity_benefic}
			</h5>
		);
	}

	return <h5 className={className}>{product.promotions?.rules?.tag}</h5>;
};
